import React, { useState, useEffect, useCallback } from 'react';
import BeheerdersportaalSidebar from '../components/BeheerdersportaalSidebar';
import api from '../components/api';
import '../css/BorstweringenAdmin.css';
import '../css/PageWithSidebar.css';

const BorstweringenAdmin = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    try {
      const res = await api.get('/api/borstweringen/admin/all');
      setData(res.data);
    } catch (err) {
      console.error('Error fetching bookings:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleDelete = async (id) => {
    if (!window.confirm('Weet u zeker dat u deze inschrijving wilt verwijderen?')) return;
    try {
      await api.delete(`/api/borstweringen/admin/${id}`);
      fetchData();
    } catch (err) {
      alert('Fout bij verwijderen');
    }
  };

  const totalBooked = data ? Object.values(data).reduce((sum, slot) => sum + slot.ingeschreven.length, 0) : 0;
  const totalWaitlist = data ? Object.values(data).reduce((sum, slot) => sum + slot.wachtlijst.length, 0) : 0;

  return (
    <BeheerdersportaalSidebar>
      <div className="borstwering-admin">
        <h1>Borstweringen Planning - Overzicht</h1>
        <p className="admin-subtitle">Weekend 28 &amp; 29 maart 2026</p>

        {loading ? (
          <p>Laden...</p>
        ) : (
          <>
            <div className="admin-stats">
              <div className="stat-card">
                <div className="stat-number">{totalBooked}</div>
                <div className="stat-label">Ingeschreven</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">{totalWaitlist}</div>
                <div className="stat-label">Wachtlijst</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">{totalBooked + totalWaitlist}</div>
                <div className="stat-label">Totaal</div>
              </div>
            </div>

            {data && Object.entries(data).map(([slotId, slot]) => (
              <div key={slotId} className="admin-slot-section">
                <h2>{slot.label}</h2>
                <p className="slot-capacity">
                  {slot.ingeschreven.length} / {slot.maxPlekken} plekken bezet
                </p>

                {slot.ingeschreven.length > 0 && (
                  <div className="table-responsive">
                    <table className="admin-table">
                      <thead>
                        <tr>
                          <th>Huisnr</th>
                          <th>Naam</th>
                          <th>E-mail</th>
                          <th>Telefoon</th>
                          <th>Ingeschreven op</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {slot.ingeschreven.map(b => (
                          <tr key={b._id}>
                            <td><strong>{b.huisnummer}</strong></td>
                            <td>{b.naam}</td>
                            <td><a href={`mailto:${b.email}`}>{b.email}</a></td>
                            <td>{b.telefoon || '-'}</td>
                            <td>{new Date(b.registeredAt).toLocaleString('nl-NL')}</td>
                            <td>
                              <button className="btn-delete" onClick={() => handleDelete(b._id)}>
                                Verwijder
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {slot.ingeschreven.length === 0 && (
                  <p className="no-bookings">Nog geen inschrijvingen</p>
                )}

                {slot.wachtlijst.length > 0 && (
                  <>
                    <h3 className="waitlist-title">Wachtlijst ({slot.wachtlijst.length})</h3>
                    <div className="table-responsive">
                      <table className="admin-table waitlist">
                        <thead>
                          <tr>
                            <th>Huisnr</th>
                            <th>Naam</th>
                            <th>E-mail</th>
                            <th>Telefoon</th>
                            <th>Ingeschreven op</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {slot.wachtlijst.map(b => (
                            <tr key={b._id}>
                              <td><strong>{b.huisnummer}</strong></td>
                              <td>{b.naam}</td>
                              <td><a href={`mailto:${b.email}`}>{b.email}</a></td>
                              <td>{b.telefoon || '-'}</td>
                              <td>{new Date(b.registeredAt).toLocaleString('nl-NL')}</td>
                              <td>
                                <button className="btn-delete" onClick={() => handleDelete(b._id)}>
                                  Verwijder
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </div>
            ))}
          </>
        )}
      </div>
    </BeheerdersportaalSidebar>
  );
};

export default BorstweringenAdmin;
